import React, {useContext} from 'react';
import {IListColumnProps} from '../../src/@interfaces/components/List/IListColumnProps';
import {ListConfigNamedColumn} from '../../src/@types/components/List';
import {IListConfigRelationColumn} from '../../src/@interfaces/components/List/IListConfigRelationColumn';
import {IOrderModel} from '../../src/@interfaces/models/Order/IOrderModel';
import {OrderPropertiesName} from '../../src/@interfaces/models/Order/IOrderPropertyModel';
import {UserContext} from '../../src/contexts/UserContext';

export default function OrderProgressColumn(
        props: IListColumnProps<ListConfigNamedColumn<IListConfigRelationColumn>, IOrderModel>
) {
    const userContext = useContext(UserContext);
    const displaySign = userContext != null &&
            userContext.model?.id &&
            props.model.manager_id === userContext.model?.id &&
            props
                    .model
                    .properties
                    ?.find(i => i.name === OrderPropertiesName.HAS_NEW_COMPLETED_PRODUCT)
                    ?.value === true;

    return <>
        {displaySign ? <i className="fa fa-exclamation-triangle text-success me-2"/> : null}

        {props.model.progress}
    </>;
}
